/* eslint-disable @typescript-eslint/no-namespace */
import { buildCDNURL } from "@platformx/utilities";
import { t } from "i18next";
import { ContentType } from "../enums/ContentType";
import { DEFAULT_EMBED_IMAGE, DEFAULT_SOCIAL_IMAGE } from "./Constants";

export const getEmbedTempData = (selectedContent: any) => {
  const { original_image = {}, tag_name = "" } = selectedContent || {};
  const relativeUrl = `${original_image?.original_image_relative_path}.${original_image?.ext}`;
  let Thumbnail = "";
  if (
    [ContentType.Quiz, ContentType.Poll, ContentType.Event, ContentType.Article].includes(
      tag_name?.toLowerCase(),
    )
  ) {
    Thumbnail = buildCDNURL(relativeUrl);
  } else if (selectedContent?.thumbnail_image) {
    Thumbnail = buildCDNURL(selectedContent?.thumbnail_image);
  } else if (tag_name?.toLowerCase() === ContentType.Vod) {
    Thumbnail = buildCDNURL(selectedContent?.Thumbnail);
  } else {
    Thumbnail = DEFAULT_EMBED_IMAGE;
  }
  const embedTempData = {
    Title: selectedContent?.title,
    Description: selectedContent?.description,
    Thumbnail,
    Author: selectedContent?.createdBy,
    lastModifiedDate: selectedContent?.creationDate,
    Page: selectedContent?.page,
    // SEO slug (empty until backend populates it); embed URLs prefer this over Page.
    slug: selectedContent?.slug || "",
    colorCode:
      (tag_name?.toLowerCase() === ContentType.Poll ||
        tag_name?.toLowerCase() === ContentType.Quiz) &&
      selectedContent?.background_content?.Color
        ? selectedContent?.background_content?.Color
        : "",
  };

  return embedTempData;
};

export const getSocialShareData = (selectedContent: any) => {
  const socialShareData = {
    Title: selectedContent?.title,
    Description: selectedContent?.description,
    Page: selectedContent?.page,
    PageSettings: {
      SocialOgTitle: selectedContent?.title,
      SocialOgImage:
        selectedContent?.tag_name === "Quiz"
          ? selectedContent?.settingsProperties?.socialog_image
            ? selectedContent?.settingsProperties?.socialog_image
            : DEFAULT_SOCIAL_IMAGE
          : selectedContent?.tag_name === "Poll"
            ? selectedContent?.settingsProperties?.socialog_image
              ? selectedContent?.settingsProperties?.socialog_image
              : DEFAULT_SOCIAL_IMAGE
            : selectedContent?.thumbnail_image
              ? selectedContent?.thumbnail_image
              : "",
      SocialOgDescription: selectedContent?.description,
    },
    Caption: "",
    ShareType: "",
    ScheduleDate: "",
    NetworkType: "",
    postURL: "",
    contentType: selectedContent?.contentType,
    reSchedulePostUrl: "",
    Thumbnail:
      selectedContent?.tag_name === "Quiz"
        ? selectedContent?.settingsProperties?.socialog_image
          ? selectedContent?.settingsProperties?.socialog_image
          : DEFAULT_SOCIAL_IMAGE
        : selectedContent?.tag_name === "Poll"
          ? selectedContent?.settingsProperties?.socialog_image
            ? selectedContent?.settingsProperties?.socialog_image
            : DEFAULT_SOCIAL_IMAGE
          : selectedContent?.thumbnail_image
            ? selectedContent?.thumbnail_image
            : DEFAULT_SOCIAL_IMAGE,
    // Doc-path (NOT slug): this is the delivery-API lookup key used by
    // getEndPathBasedContentType to fetch OG title/description/image
    // (`*-model?pagePath=<CurrentPageURL>`). That endpoint resolves by stored
    // doc path, so it must stay the doc path — slugging it breaks the OG fetch.
    CurrentPageURL: selectedContent?.current_page_url,
    // Slug-first public share URL segment (doc-path fallback), used only to
    // build the human-facing share link — decoupled from the lookup key above.
    PublicPageURL: selectedContent?.slug
      ? `/${selectedContent.slug}`
      : selectedContent?.current_page_url,
  };
  return socialShareData;
};

export const onBackButtonEvent = (e, unsavedChanges, setDialogOpen, navigateTo) => {
  e.preventDefault();
  window.history.pushState(null, "", window.location.pathname + window.location?.search);
  if (unsavedChanges) {
    setDialogOpen(true);
  } else {
    if (e === "") {
      navigateTo(); //not required need remove
    }
    return;
  }
};
export const unloadCallback = (event, unsavedChanges) => {
  event.preventDefault();
  if (unsavedChanges) {
    event.returnValue = "";
    return "";
  }
};

export const quizResponseMapper = (res, quizState, tempArray) => {
  // console.log("FCM Notification Data:", res);
  return {
    ...quizState,
    title: res?.data?.authoring_getCmsContentByPath?.title,
    short_title: res?.data?.authoring_getCmsContentByPath?.short_title,
    short_description: res?.data?.authoring_getCmsContentByPath?.short_description,
    description: res?.data?.authoring_getCmsContentByPath?.description,
    imagevideoURL: res?.data?.authoring_getCmsContentByPath?.background_content?.Url,
    colorCode: res?.data?.authoring_getCmsContentByPath?.background_content?.Color,
    questions: tempArray,
    // questions: res?.data?.authoring_getCmsContentByPath?.questions.length>0 ? [...quizState.questions,{current_page_url:res?.data?.authoring_getCmsContentByPath?.questions}]:quizState.questions,
    scoreBy: res?.data?.authoring_getCmsContentByPath?.display_scores,
    tags: res?.data?.authoring_getCmsContentByPath?.tags,
    result_range_1: res?.data?.authoring_getCmsContentByPath?.result_range_1,
    result_range_2: res?.data?.authoring_getCmsContentByPath?.result_range_2,
    result_range_3: res?.data?.authoring_getCmsContentByPath?.result_range_3,
    result_range_4: res?.data?.authoring_getCmsContentByPath?.result_range_4,
    original_image: res?.data?.authoring_getCmsContentByPath?.original_image,
    published_images: res?.data?.authoring_getCmsContentByPath?.published_images,
    is_schedule_publish:
      res?.data?.authoring_getCmsContentByPath?.settingsProperties?.is_schedule_publish,
    is_schedule_unpublish:
      res?.data?.authoring_getCmsContentByPath?.settingsProperties?.is_schedule_unpublish,
    schedule_publish_datetime:
      res?.data?.authoring_getCmsContentByPath?.settingsProperties?.schedule_publish_datetime,
    schedule_unpublish_datetime:
      res?.data?.authoring_getCmsContentByPath?.settingsProperties?.schedule_unpublish_datetime,
    socialShareImgURL: res?.data?.authoring_getCmsContentByPath?.settingsProperties?.socialog_image,
    titleSocialShare: res?.data?.authoring_getCmsContentByPath?.settingsProperties?.socialog_title,
    descriptionSocialShare:
      res?.data?.authoring_getCmsContentByPath?.settingsProperties?.socialog_description,
    tagsSocialShare: res?.data?.authoring_getCmsContentByPath?.settingsProperties?.keywords,
    structure_data: res?.data?.authoring_getCmsContentByPath?.structure_data || "",
    seo_enable: res?.data?.authoring_getCmsContentByPath?.seo_enable,
    analytics_enable: res?.data?.authoring_getCmsContentByPath?.analytics_enable,
    createdBy: res?.data?.authoring_getCmsContentByPath?.createdBy,
    // Add FCM notification fields
    notification: res?.data?.authoring_getCmsContentByPath?.notification || false, //String(res?.data?.authoring_getCmsContentByPath?.notification) === "true",
    notification_title:
      res?.data?.authoring_getCmsContentByPath?.notification_title ||
      res?.data?.authoring_getCmsContentByPath?.title,
    notification_desc:
      res?.data?.authoring_getCmsContentByPath?.notification_desc ||
      res?.data?.authoring_getCmsContentByPath?.description,
    notification_image: res?.data?.authoring_getCmsContentByPath?.notification_image || "",
    notification_channel: res?.data?.authoring_getCmsContentByPath?.notification_channel || [],
    notification_topics: res?.data?.authoring_getCmsContentByPath?.notification_topics || [],
    content_behind_rendering:
      res?.data?.authoring_getCmsContentByPath?.content_behind_rendering || "Free",
  };
};

export const getCurrentQuiz = (res) => {
  return {
    title: res?.data?.authoring_getCmsContentByPath?.title,
    short_title: res?.data?.authoring_getCmsContentByPath?.short_title,
    short_description: res?.data?.authoring_getCmsContentByPath?.short_description,
    description: res?.data?.authoring_getCmsContentByPath?.description,
    imagevideoURL: res?.data?.authoring_getCmsContentByPath?.background_content?.Url,
    colorCode: res?.data?.authoring_getCmsContentByPath?.background_content?.Color,
    tags: res?.data?.authoring_getCmsContentByPath?.tags,
    titleSocialShare: res?.data?.authoring_getCmsContentByPath?.settingsProperties?.socialog_title,
    descriptionSocialShare:
      res?.data?.authoring_getCmsContentByPath?.settingsProperties?.socialog_description,
    socialShareImgURL: res?.data?.authoring_getCmsContentByPath?.settingsProperties?.socialog_image,
    tagsSocialShare: res?.data?.authoring_getCmsContentByPath?.settingsProperties?.keywords,
    // Add FCM notification fields
    notification: res?.data?.authoring_getCmsContentByPath?.notification || false,
    notification_title: res?.data?.authoring_getCmsContentByPath?.notification_title || "",
    notification_desc: res?.data?.authoring_getCmsContentByPath?.notification_desc || "",
    notification_image: res?.data?.authoring_getCmsContentByPath?.notification_image || "",
    notification_channel: res?.data?.authoring_getCmsContentByPath?.notification_channel || [],
    notification_topics: res?.data?.authoring_getCmsContentByPath?.notification_topics || [],
    content_behind_rendering:
      res?.data?.authoring_getCmsContentByPath?.content_behind_rendering || "",
  };
};
export const onError = (id) => {
  const goToError = document.getElementById(`${id}`);
  if (goToError) goToError.scrollIntoView({ behavior: "smooth", block: "end" });
};
export const notificationTitleSubTitles = () => {
  return {
    // Section Info
    // sectionNumber: "09",
    sectionTitle: t("Notification"),
    sectionSubTitle: t("subhead"),

    // Notification Settings
    notificationTitle: `${t("Notification Setting")}`,
    notificationSubTitle: t("event_analytics_subhead"),
    notificationFieldName: "notification",

    // Image Configuration
    notificationImageTitle: "Choose Image",
    notificationImageSubTitle: "Choose Image",
    notificationImageFieldName: "notification_image",

    // Main Title Configuration
    mainTitle: t("What's the notification Title"),
    mainSubTitle: t("quiz_ss_subtitle"),
    titlePlaceHolder: t("quiz_title_placeholder"),
    titleFieldName: "notification_title",
    titleMaxCharLength: 120,

    // Description Configuration
    descriptionTitle: "What's the notification Description",
    descriptionSubTitle: t("quiz_ss_subdescription"),
    descriptionPlaceHolder: t("quiz_description_placeholder"),
    descriptionFieldName: "notification_desc",
    descriptionMaxCharLength: 400,

    // Destination Configuration
    destinationTitle: "What's the notification destination path",
    destinationSubTitle: "Enter the destination URL",
    destinationPlaceHolder: "http://example.com",
    destinationFieldName: "notification_destination_path",

    // Channel Configuration
    channelTitle: "What's the notification channel title",
    channelSubTitle: "Select channel name to be published",
    channelFieldName: "notification_channel",

    // Topic Configuration
    notificationTopic: "What's the notification topic",
    notificationSubTopic: "Select the notification topic",
    notificationTopicFieldName: "notification_topics",
  };
};

export const notificationAllkey = {
  notification: false,
  notification_desc: "",
  notification_channel: [],
  notification_topics: [],
  notification_title: "",
  notification_image: "",
};

export const contentStatusTitleSubTitles = () => {
  return {
    // Section Info
    // sectionNumber: "10",
    sectionTitle: t("Content Status"),
    sectionSubTitle: t("subhead"),

    // Content Status
    contentStatusTitle: t("What's the Content Status"),
    contentStatusSubTitle: t("Content status can be Free/ Behind Login /Behind Subscription"),
    contentStatusFieldName: "content_behind_rendering",
  };
};
export const getCategoryTags = (arr1, arr2) => {
  if (arr1?.length > 0 && arr2?.length > 0) {
    const result: any = [];
    arr1?.forEach((item) => {
      const { category, tags } = item;
      tags.forEach((tag) => {
        if (arr2.includes(tag)) {
          result.push(`${category}/${tag}`);
        }
      });
    });
    return result;
  }
};
